/** @format */

import React, { useEffect, useState } from 'react';
import GridItem from '../../../../components/Grid/GridItem';
import { PlatformResellerCollectionInterface } from '../../../../interfaces/collections/PlatformResellerCollectionInterface';
import { PlatformResellerHelper } from '../../../../helpers/PlatformResellerHelper';
import { Auth } from '../../../../modules/auth/Auth';
import SimpleSelectRest from '../../../../components/Adescom/SimpleSelectRest';

interface OnlyPlatformResellerFormProps {
    platformResellerList: PlatformResellerCollectionInterface | null;
    platformResellerId: Array<number>;
    handleChangeMultiple: (event: any) => void;
}

const OnlyPlatformResellerForm = (props: OnlyPlatformResellerFormProps): React.ReactElement => {
    const { platformResellerList, platformResellerId } = props;
    const [hasChildren, setHasChildren] = useState<boolean>(false);

    useEffect(() => {
        if (platformResellerList && platformResellerList['hydra:member'].length > 0) {
            if (PlatformResellerHelper.hasChildrenResellers(Auth.getUserPlatformResellerId(), platformResellerList['hydra:member'])) {
                setHasChildren(true);
            }
        }
    }, [platformResellerList]);

    return (
        <GridItem xs={4}>
            <SimpleSelectRest
                callback={(event: any): void => {
                    let ev = event;
                    ev.target.value = [event.target.value];
                    props.handleChangeMultiple(ev);
                }}
                restElements={
                    platformResellerList
                        ? {
                              'hydra:member': platformResellerList['hydra:member'].map((el) => {
                                  return { name: el.mainname, value: el.id };
                              }),
                          }
                        : []
                }
                stateName="platformResellerId"
                idState="platformResellerId"
                idSelected={platformResellerId}
                propKey="value"
                required={false}
                propValue="name"
                emptyLabel="general:common.empty_label"
                label="specialized_report:h.select_platform_reseller"
            />
        </GridItem>
    );
};

export default OnlyPlatformResellerForm;
